module.exports = __webpack_public_path__ + "static/img/map__currentlocation__icon.6a74f916.svg";